import { Component } from '@angular/core';

@Component({
  selector: 'app-radio-player',
  templateUrl: './radio-player.component.html',
  styleUrl: './radio-player.component.css'
})
export class RadioPlayerComponent {

}
